import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { projectedFieldsForSlot } from './expand.js';
import { FieldRow } from '../atoms/Section.js';
import { v } from '../atoms/format.js';
export function PartyBlock(props) {
    const fields = projectedFieldsForSlot(props.metadata, props.slot);
    if (fields.length === 0)
        return null;
    return (_jsxs(_Fragment, { children: [props.subheading ? (_jsx("div", { className: "mt-2 mb-1 font-sans text-[10px] uppercase tracking-[0.1em] text-stone-500", children: props.subheading })) : null, fields.map((f) => (_jsx(FieldRow, { label: f.label, children: v(props.values[f.key]) }, f.key)))] }));
}
//# sourceMappingURL=PartyBlock.js.map